import styled from 'styled-components';
import { Tooltip, Box } from '@mui/material';

export const Title = styled.p`
  font-weight: bold;
`;

export const TooltipIcon = styled(Tooltip)`
  color: #ccc;
  margin-left: 4px;
`;

export const TooltipWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
`;

export const BoxButton = styled(Box)`
  .btnDanfe {
    background-color: #fff;
    color: #cf8200;
    border: 1px solid #cf8200;
    justify-content: flex-start !important;

    @media (max-width: 768px) {
      justify-content: center !important;
    }

    &:hover {
      border: 1px solid #ad7000;
      color: #ad7000;
    }
  }

  .btnDanfeDisabled {
    background-color: #fff;
    color: #bbb;
    border: 1px solid #ccc;
    justify-content: flex-start !important;
    cursor: auto;

    @media (max-width: 768px) {
      justify-content: center !important;
    }

    // &:hover {
    //   border: 1px solid #ad7000;
    //   color: #ad7000;
    // }
  }
`;

export const LabelFileInput = styled.label`
  height: 36.5px;
  padding: 6px 16px;
  background-color: #fff;
  color: #e38500;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid rgba(227, 133, 0, 0.5);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background-color: #fefaf5;
    border: 1px solid #e38500;
  }
`;

export const FileInput = styled.input`
  display: none;
`;
